import { render } from "./ScreenActions.vue?vue&type=template&id=20a3ed47"
import script from "./ScreenActions.vue?vue&type=script&lang=js"
export * from "./ScreenActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__